module.exports = __webpack_public_path__ + "static/media/plages.b50fa4c4.jpg";